import React, { useContext } from "react";
import classes from "./Partner.module.css";
import { mouseContext } from "../../context/mouseContext";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";

import "swiper/css";
import "swiper/css/autoplay";

/* Partner Logos */
import img2 from "../../assets/partners/msme.png";
import img3 from "../../assets/partners/Biswa_Bangla.jpg";
import img4 from "../../assets/img/nasscom.jpg";
import img5 from "../../assets/img/bcc.jpg";
import img6 from "../../assets/partners/iqponics.png";
import img7 from "../../assets/img/STPI.png";
import img8 from "../../assets/partners/STPINEXT.png";
import img9 from "../../assets/img/ISI.png";
import img10 from "../../assets/partners/agro.jpg";
import img11 from "../../assets/partners/iitkgpagribusinesstbi.png";
import img12 from "../../assets/partners/healing.png";
import img13 from "../../assets/partners/zamsof.jpg";
import img15 from "../../assets/partners/stcht.png";
import img16 from "../../assets/partners/digital.png";
import img17 from "../../assets/partners/phonepay.webp";

const Partner = () => {
  const { mouseEnterHandler, mouseLeaveHandler } = useContext(mouseContext);

  const images = [
    img2,
    img3,
    img4,
    img5,
    img6,
    img7,
    img8,
    img9,
    img10,
    img11,
    img12,
    img13,
    img15,
    img16,
    img17,
  ];

  return (
    <section className={classes.wrapper} aria-label="Trusted Partners">
      {/* Section Heading */}
      <div className="section-title">
        <h1 className="section-heading">We Are Recognised & Trusted By</h1>
        <h5 className="section-subheading">THE COUNT IS GOING ON</h5>
      </div>

      {/* Partner Slider */}
      <div className={classes.partners}>
        <Swiper
          loop
          speed={6000}
          spaceBetween={30}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          breakpoints={{
            320: { slidesPerView: 2, spaceBetween: 10 },
            480: { slidesPerView: 3, spaceBetween: 15 },
            640: { slidesPerView: 4, spaceBetween: 20 },
            768: { slidesPerView: 5, spaceBetween: 25 },
            1024: { slidesPerView: 6, spaceBetween: 30 },
            1280: { slidesPerView: 7, spaceBetween: 40 },
          }}
          modules={[Autoplay]}
        >
          {images.map((image, index) => (
            <SwiperSlide key={index}>
              <div
                className={classes.partner}
                onMouseEnter={mouseEnterHandler}
                onMouseLeave={mouseLeaveHandler}
              >
                <img
                  src={image}
                  alt="Partner Logo"
                  loading="lazy"
                  draggable="false"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Partner;
